// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

type Payload = {
  username: string,
  password: string,
  merchant_group_id?: number,
};

const login = wrapWithNetworkError(function login(
  username,
  password,
  clientId
) {
  const body: Payload = { username, password };
  if (typeof clientId === 'number') {
    body.merchant_group_id = clientId;
  }

  const fetchUrl = getEndpointUrl('/login');
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
    },
    body: JSON.stringify(body),
  };

  return fetch(fetchUrl, fetchOptions)
    .then(response => checkResponse(response))
    .then(response => response.json())
    .catch(err => {
      if (err.status < 500) {
        if (err.status === 400) {
          err.message = 'Username/Password required.';
        }
        if (err.status === 401) {
          err.message = 'Incorrect Username/Password.';
        }
      }

      return Promise.reject(err);
    });
});

export default login;



// WEBPACK FOOTER //
// ./src/api/auth/login.js